import 'xp-lib-brand/index'; // import xp-lib-brand js first

import PlantMap from './parts/plant-map';

// Assign to window to be accessible from DOM script
window.PlantMap = PlantMap;
